export default "__VITE_ASSET__Cdow2IuO__"